// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1FbKo","messages":"Chat_messages__1lRO2","dateDivider":"Chat_dateDivider__29q5X"};